/**
 * 特性翻译模块 - 中文
 *
 * SEO 关键词覆盖：
 * - 远红外取暖器 / 辐射加热器
 * - 节能 / 节能省电
 * - 纳米涂层 / 发射率
 */

import type { FeaturesTranslations } from '../../types';

export const zhFeatures: FeaturesTranslations = {
  tech: {
    title: '创新远红外发热元件',
    description: '晶辉远红外取暖器发射的远红外线可直接作用于人体和物体——如同自然阳光般温暖舒适。这种辐射加热方式升温迅速、均匀、静音，无噪音、无风、无光、无粉尘，比传统对流取暖器节能高达80%。',
    aluminum: '翅片式特殊铝合金结构，快速导热',
    nano: '专利纳米陶瓷涂层，最大化远红外线发射',
    insulation: '86%远红外线发射效率——行业领先水平',
    lifespan: '专利蓄热反射技术（节能20%以上）',
  },
};
